import PropTypes from 'prop-types';

export default PropTypes.shape({
    s: PropTypes.shape({
        cpu: PropTypes.number,
        screen: PropTypes.number,
        totalTime: PropTypes.number,
    }),
    gb: PropTypes.shape({
        mem: PropTypes.number,
        disk: PropTypes.number,
        network: PropTypes.number,
    }),
    wh: PropTypes.shape({
        cpu: PropTypes.number,
        mem: PropTypes.number,
        disk: PropTypes.number,
        total: PropTypes.number,
        screen: PropTypes.number,
        network: PropTypes.number,
    }),
    co2: PropTypes.shape({
        cpu: PropTypes.number,
        mem: PropTypes.number,
        disk: PropTypes.number,
        total: PropTypes.number,
        screen: PropTypes.number,
        network: PropTypes.number,
    }),
});
